export default function DiScreenBadge({message, className}) {
  return (
     <div className={'di-screen-badge abosulte right-10 top-10 ' + className} >{message}</div>
  )
}
